import React, { Component } from 'react';
import '../../../App.scss';
import 'antd/dist/antd.css';
import { PageHeader } from 'antd';

import AdminPayTipRequestsBody from '../../../components/admin/AdminPayTipRequestsBody';

// /admin/paytip-requests
export default class AdminPayTipRequestsScreen extends Component {
  constructor(props) {
    super(props);
    const { isAdmin } = props;
    this.isAdmin = isAdmin;
  }

  render() {
    return (
      <div style={{ height: '100%', textAlign: 'center' }}>
        <PageHeader
          ghost={false}
          title="Pay + Tip Requests"
          subTitle="Teams asking for Pay + Tip — the grant queue"
          onBack={() => window.history.back()}
        />
        <AdminPayTipRequestsBody isAdmin={this.isAdmin} />
      </div>
    );
  }
}
